module.exports = __webpack_public_path__ + "img/GB21.dadc39d2.webp";